// @tennis-matches/services/governance
// Zentrale Validierung: scope_id muss für scope='tenant' eine UUID sein.
// Verhindert, dass neue Slug-basierte scope_ids in Governance-Tabellen geschrieben werden.

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const SYSTEM_SCOPE_IDS = new Set([
  "__pending_new_club__",
  "__independent_trainer__",
  "global",
]);

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isUuidScopeId(value) {
  return typeof value === "string" && UUID_RE.test(value.trim());
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isSystemScopeId(value) {
  return typeof value === "string" && SYSTEM_SCOPE_IDS.has(value.trim());
}

/**
 * Prüft, dass eine scope_id für scope='tenant' entweder eine UUID oder
 * ein bekannter System-Platzhalter ist. Gibt ein Result-Objekt zurück.
 *
 * @param {string} scopeId
 * @param {{ allowSystemPlaceholders?: boolean }} [opts]
 * @returns {{ valid: boolean, reason?: string }}
 */
export function validateTenantScopeId(scopeId, { allowSystemPlaceholders = false } = {}) {
  const sid = typeof scopeId === "string" ? scopeId.trim() : "";
  if (!sid) return { valid: false, reason: "missing-scope-id" };
  if (isUuidScopeId(sid)) return { valid: true };
  if (allowSystemPlaceholders && isSystemScopeId(sid)) return { valid: true };
  return { valid: false, reason: "invalid-scope-id-not-uuid" };
}

/**
 * Guard für Governance-Schreiboperationen. Gibt ein sofortiges
 * Fehler-Result zurück, falls die scope_id ungültig ist.
 *
 * @param {string} scope
 * @param {string} scopeId
 * @param {{ allowSystemPlaceholders?: boolean }} [opts]
 * @returns {{ ok: false, reason: string } | null} null = valid
 */
export function rejectInvalidTenantScopeId(scope, scopeId, opts) {
  const s = typeof scope === "string" ? scope.trim().toLowerCase() : "";
  if (s !== "tenant") return null;
  const result = validateTenantScopeId(scopeId, opts);
  if (result.valid) return null;
  return { ok: false, reason: result.reason };
}
